// extracted by mini-css-extract-plugin
export default {"iconLink":"LkButton_iconLink__Qc5bA","icon":"LkButton_icon__ihKpX","iconLinkActive":"LkButton_iconLinkActive__Nwx0c"};